<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { FrappeUIProvider } from 'frappe-ui'
import { session } from './session'
import AppShell from './layouts/AppShell.vue'
import AuthLayout from './layouts/AuthLayout.vue'
import PublicLayout from './layouts/PublicLayout.vue'
import ServerUnreachable from './components/ServerUnreachable.vue'

const route = useRoute()
const isAuth = computed(
  () => route.meta.layout === 'auth' || route.name === 'Login',
)
const isPublicMarket = computed(() => route.meta.layout === 'public')
</script>

<template>
  <FrappeUIProvider>
    <div class="min-h-screen bg-surface-base text-ink-gray-9">
      <!-- Only block render during the very first boot fetch, not subsequent API calls -->
      <ServerUnreachable v-if="session.unreachable" />
      <div
        v-else-if="!session.loaded"
        class="flex min-h-screen items-center justify-center"
      >
        <span
          class="lucide-loader-circle size-6 animate-spin text-ink-gray-5"
          aria-hidden="true"
        />
      </div>
      <template v-else>
        <AuthLayout v-if="isAuth">
          <router-view />
        </AuthLayout>
        <PublicLayout v-else-if="isPublicMarket">
          <router-view />
        </PublicLayout>
        <AppShell v-else-if="session.boot.authenticated">
          <router-view />
        </AppShell>
        <router-view v-else />
      </template>
    </div>
  </FrappeUIProvider>
</template>
